<div><h2 v-html="field.values[0]"></h2><p v-if="field.values[1]" v-html="field.values[1]"></p></div>